import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import DemoHeader from './DemoHeader';
import SelectFileHeader from './SelectFileHeader';
import SelectFileInput from './SelectFileInput';
import DemoSearchHeader from './DemoSearchHeader';
import DemoSearch from './DemoSearch';
import ResultCard from './ResultCard';
import SearchResultContainer from './SearchResultContainer';

const Demo = ({ history }) => {

  history.listen(() => {
      window.scrollTo(0, 0);
  });

  const [disableBtn, setDisableBtn] = useState('');
  const [uploaded, setUploaded] = useState(false);
  const [tweets, setTweets] = useState([]);
  const [searchFilter, setSearchFilter] = useState('');

  useEffect(() => {

    const fetchTweets = async () => {
      const fetchedTweets = await axios.get('https://saveforlater.herokuapp.com/images/all');

      setTweets(fetchedTweets.data);
    }

    fetchTweets();

    setUploaded(false);
    setDisableBtn('');

  }, [uploaded]);

  async function handleFileUpload(fileInput) {
    setDisableBtn('disable');

    const formData = new FormData();

    formData.append('tweetImg', fileInput);

    await axios.post('https://saveforlater.herokuapp.com/tweet-upload', formData);

    setTimeout(() => {
      setUploaded(true);
    }, 1000);
  }

  const filteredTweets = tweets.filter(tweet => {
    return tweet.content.toLowerCase().includes(searchFilter.toLowerCase());
  });

  const searchResults = searchFilter !== '' ? filteredTweets.map(tweet => {
    return (
      <ResultCard key={tweet._id} url={tweet.url} />
    );
  }) : null;

  return (
    <div className="demoContainer">
      <DemoHeader />
      <SelectFileHeader />
      <SelectFileInput 
        onUpload={handleFileUpload} 
        didUpload={uploaded} 
        isDisabled={disableBtn} />
      <DemoSearchHeader />
      <DemoSearch setFilter={setSearchFilter} />
      <SearchResultContainer>
        {searchResults}
      </SearchResultContainer>
    </div>
  );
};

export default withRouter(Demo);